export default "__VITE_ASSET__eJfjL2Z7__"